export default __webpack_public_path__ + "static/media/logo-rose.b46cdc14.png";